import { formatearFecha, formatearRevision, NOMBRE_ESTADO } from "@gestiondoc/shared";
import type { Detalle } from "../tipos.ts";
import { abreviarNombre } from "../utiles.ts";
import { Pildora, Tarjeta } from "./ui.tsx";

/** La tarjeta "Historial de revisiones" del documento: una fila por revisión, nada se borra. */
export function HistorialDeRevisiones({
  revisiones,
  puedeDescargar,
}: {
  revisiones: Detalle["revisiones"];
  puedeDescargar: boolean;
}) {
  return (
    <Tarjeta
      titulo="Historial de revisiones"
      ayuda="Nada se sobreescribe. Cada revisión conserva su archivo y sus firmas."
    >
      <table className="w-full text-[13px]">
        <tbody>
          {revisiones.map((r) => (
            <tr key={r.id} className="border-b border-borde/60 last:border-0">
              <td className="py-2.5 pr-3 font-mono font-semibold text-marino">
                {formatearRevision(r.numero)}
              </td>
              <td className="py-2.5 pr-3">
                <Pildora
                  tono={
                    r.estado === "vigente" ? "bg-verde-fondo text-verde" : "bg-gris-fondo text-gris"
                  }
                >
                  {NOMBRE_ESTADO[r.estado]}
                  {r.aprobadaEn && r.estado !== "borrador"
                    ? ` · ${formatearFecha(r.aprobadaEn)}`
                    : ""}
                </Pildora>
              </td>
              <td className="py-2.5 text-texto-2">
                {/* Un motivo largo (el historial de cambios entero) se corta a tres renglones;
                    completo se ve al pasar el mouse, en Comparar y, el de la principal, arriba. */}
                <span className="line-clamp-3 whitespace-pre-line" title={r.motivo}>
                  {r.motivo}
                </span>
                {r.firmasPapel.length > 0
                  ? r.firmasPapel.map((p) => abreviarNombre(p.nombre)).join(" / ")
                  : abreviarNombre(r.creadoPor.nombre)}
                {r.pdfSellado && puedeDescargar && (
                  <a
                    href={`/archivos/${r.pdfSellado.id}`}
                    className="ml-1 font-semibold text-marino hover:underline"
                  >
                    · PDF sellado
                  </a>
                )}
                {r.origen === "importado" && (
                  <span className="ml-1 font-semibold text-texto-3">· Aprobada en papel</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Tarjeta>
  );
}
